export const ESchmetterlingOrderStatus = {
  "0": "UNKNOWN",
  "200": "BOOKED",
  "201": "OPTIONAL_BOOKED",
  "202": "CANCELED",
  "205": "DISPLAYED",
  "213": "RESERVED",
  "-1": "ALL"
};